import React, { useEffect, useState } from "react";
import ServiceList from "modules/services/components/ServiceList";
import Consultation from "components/Consultation";
import ServiceApi from "api/services";
import BlogsApi from "api/blogs";
import PageCard from "modules/pages/PageCard";
import PageCardB from "modules/pages/PageCardB";
import PageCardC from "modules/pages/PageCardC";
import PageCardE from "modules/pages/PageCardE";
import PageCardF from "modules/pages/PageCardF";
import VideoEmbed from "modules/testimonials/components/VideoEmbed";
import Modal from "components/Modal";
import NoList from "components/NoList";
import Title from "components/Title";
import SEO from "components/SEO";
import Testimonials from "./Testimonials";
import ChairmansMessage from "./ChairmansMessage";
import Blogs from "./Blogs";
// import ForeignGuests from './ForeignGuests'
import PhotoOfDay from "./PhotoOfDay";
// import About from './About'
import VideoSlider from "./VideoSlider";
import WithHeaderAndFooter from "navigation/layouts/WithHeaderAndFooter";
import HomeBanner from "components/HomeBann/HomeBanner";
import OwlCarousel from 'react-owl-carousel2'
import Service from "modules/services/components/Service";
import LabreportModal from "modules/consultation-list/modals/LabreportModal";
import { Link, useHistory} from "react-router-dom";
import TestimonialMobile from "./TestimonialMobile";
import NewBranchBanner from "components/NewBranch/NewBranchBanner";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const Home = () => {
  const { data } = ServiceApi.readServices(true);
  const { data: blogs } = BlogsApi.readBlogs(true);

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const options = {
    items: 1, // Show one item at a time
    center: true, // Center the active item
    nav: true, // Enable navigation
    navText: [
      '<i class="fas fa-chevron-left"></i>', // Custom previous icon
      '<i class="fas fa-chevron-right"></i>' // Custom next icon
    ]
  };

  console.log('service data is', data)

  const carouselOptions = {
    items: 2,
    loop: true,
    margin: 10,
    // nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    navText: [
      '<img src="/img/arrow-right.svg" id="custom-prev">',
      '<img src="/img/arrow-right.svg" id="custom-next">'
    ],
    // navText:["<span aria-label=\"Previous\">‹</span>","<span aria-label=\"Next\">›</span>"],
    // responsiveClass: true,
    responsive: {
      0: {
        items: 1.5,
      },
      480: {
        items: 1,
      },
      768: {
        items: 2,
      },
      992: {
        items: 2,
      },
      1200: {
        items: 2,
      },
    },
  }

  const renderServiceList = data ? (
    <ServiceList
      // count={8}
      list={data}
      className="services-wrapper"
      itemClassName="col-lg-3 col-md-3 col-sm-6 col-12"
    />
  ) : (
    <NoList />
  );

  // const renderBlogList = blogs ? <Blogs list={blogs} /> : <NoList />

  const [videoOpen, setVideoOpen] = useState(false);
  const [videoId, setVideoId] = useState();
  const [labModal, setLabModal] = useState(false)
  const history = useHistory()
  const [isVisible, setIsVisible] = useState(true);

  const openLabModal = () => {
    setLabModal(true);
  }

  const handleScroll = () => {
    // Calculate the scroll position as a percentage of the page height
    const scrollPosition = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;

    // Update the visibility of the button based on the scroll position
    setIsVisible(scrollPosition <= 50);
  };

  useEffect(() => {
    // Attach the scroll event listener when the component mounts
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // console.log(videoId)

  return (
    <div style={{ 
      maxWidth: '100vw', 
      overflowX: 'hidden', 
    }}>
      <SEO />
      <HomeBanner />
      <NewBranchBanner />
      {/* <Consultation /> */}
      <section className="service-testimonial-wrapper" style={{marginTop: 0,overflowX: "hidden",maxWidth: "100vw"}}>
        <img className="service-bubbles" src="/img/bubbles.svg" />
        <div className="container outer-wrapper-menu" style={{marginLeft: 0, marginRight: 0,paddingLeft: 0, paddingRight: 0}}>
          <div className="row" style={{marginLeft: 0, marginRight: 0}}>
            <div className="col-lg-12">
              <div className="services-wrapper services-desktop">
                <h3 className="our-services wow bounceInLeft">Our Services</h3>
                <h5 className="experience-the-best wow bounceInLeft">Experience the Best in Healthcare</h5>
                {renderServiceList}
              </div>
              <div className="services-mobile">
              <h3 className="our-services-mobile wow bounceInLeft">Our Services</h3>
                <h5 className="experience-the-best-mobile wow bounceInLeft">Experience the Best in<br/> Healthcare</h5>
                <div className="newsevents-slider-wrapper wow fadeInUp">
            {data && data.length > 0 && (
              <OwlCarousel
                options={carouselOptions}
                className="owl-carousel owl-theme newsevents-slider nav-right-top"
              >
                {data.map(item => (
                  <div key={item._id} className="item">
                    <Service
              
             
              id={item.slug}
              key={item._id}
              title={item.title}
              imageTag={item.imageTag}
              icon={`${BASE_URL}/${item.icon.thumbnail}`}
              shortDescription={item.shortDescription}
            />
                  </div>
                ))}
              </OwlCarousel>
            )}
            {(!data || (data.length === 0)) && <NoList message="No blogs to display" />}
          </div>
              </div>
            </div>
            <ChairmansMessage url={BASE_URL + "/api/pages/chairman-s-message"} />
            <PageCardE
              title="About Us"
              url={BASE_URL + "/api/pages/about-us"}
            />
            <div className="testimonial-outer-division">
              <img className="testimonial-pattern-mobile" src="/img/testimonial-pattern.svg"></img>
            <div className="testimonial-title-pos wow testimonial-background">
                <h3 className="testimonial-title">Testimonial</h3>
                <h2 className="words-of-appreciation">Words of Appreciation <br/> and Trust</h2>
                </div>
                <div className="test-outer-wrap wow fadeInUp">
                <Testimonials
                      commentsUrl={BASE_URL + "/api/comments?status=active&sort=priorityOrder"}
                      videosUrl={BASE_URL + "/api/videos"}
                      handleVideoClick={(id) => {
                        setVideoOpen(true);
                        setVideoId(id);
                      }}
                    />

                </div>

            </div>
          </div>
        </div>
        <div className="col-lg-12">
              {/* <ForeignGuests /> */}
              <PageCardB url={BASE_URL + "/api/pages/foreign-guests"} />
            </div>
            <div className="col-lg-12 total-outer-wrap photo-collection-day">
              <PhotoOfDay url={BASE_URL + "/api/photos"} />
            </div>

            <div className="col-lg-12 video-slider-wrapper">
            <VideoSlider
                onClickModal={(id) => {
                  setVideoOpen(true);
                  setVideoId(id);
                }}
              />
            </div>

        
        {/* {renderBlogList} */}
       <div className="news-events-wrapper">
        <Blogs list={blogs} />
        </div>
      </section>
      <Modal isShow={videoOpen} handleModalClose={() => setVideoOpen(false)}>
        <Modal.Body>
          <VideoEmbed videoId={videoId} height="450" />
        </Modal.Body>
      </Modal>
      <LabreportModal labModal={labModal} setLabModal={setLabModal} />
    </div>
  );
};

export default WithHeaderAndFooter(Home);
